import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "infographics-container" }
const _hoisted_3 = { class: "infographics-header-block text-center" }
const _hoisted_4 = { class: "infographics-logo" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h1", null, "CONVORALLY", -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "step-tab" }
const _hoisted_8 = { class: "step-content" }
const _hoisted_9 = { class: "help-container scrollable" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-3" }
const _hoisted_12 = { class: "help-img" }
const _hoisted_13 = { class: "col-9 align-self-center" }
const _hoisted_14 = { class: "help-text" }
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = { class: "step-move" }
const _hoisted_17 = { class: "step-prev" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" }, null, -1)
const _hoisted_19 = { class: "step-next" }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-right" }, null, -1)
const _hoisted_21 = { class: "final-container" }
const _hoisted_22 = { class: "final-block" }
const _hoisted_23 = { class: "container" }
const _hoisted_24 = { class: "final-wrap" }
const _hoisted_25 = { class: "convorally-moto" }
const _hoisted_26 = { class: "italic" }
const _hoisted_27 = { class: "final-img-wrap" }
const _hoisted_28 = /*#__PURE__*/_createVNode("p", null, "www. ", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("p", null, ".com", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_P = _resolveComponent("P")
  const _component_TutorialStep = _resolveComponent("TutorialStep")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("section", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convoicon-blue.png`: 'timg/convoicon-blue.png' ,
            alt: ""
          }, null, 8, ["src"])
        ]),
        _hoisted_5,
        _createVNode("h2", null, _toDisplayString(_ctx.$t('project_manager_app')), 1),
        _createVNode(_component_P, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('project_manager_description')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_TutorialStep)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("img", {
                    src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/call-service.png`: 'timg/call-service.png' ,
                    alt: ""
                  }, null, 8, ["src"])
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('reach_out_to_help_desk_located_at_the')) + " ", 1),
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('footer_of_the_application_to_resolve_your_issue')) + ".", 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToStep6 && _ctx.redirectToStep6(...args)))
              }, [
                _hoisted_18
              ])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToStep8 && _ctx.redirectToStep8(...args)))
              }, [
                _hoisted_20
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_21, [
      _createVNode("section", _hoisted_22, [
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, [
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/comment.png`: 'timg/comment.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('building_confidence_trust')) + " – ", 1),
                _createVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('one_convo_at_a_time')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convorally-text.png`: 'timg/convorally-text.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _hoisted_29
            ])
          ])
        ])
      ])
    ])
  ]))
}